import { render, staticRenderFns } from "./log6.vue?vue&type=template&id=807dc966&scoped=true"
import script from "./log6.vue?vue&type=script&lang=js"
export * from "./log6.vue?vue&type=script&lang=js"
import style0 from "./log6.vue?vue&type=style&index=0&id=807dc966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807dc966",
  null
  
)

export default component.exports